import { useCallback } from "react";
import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";

export const usePermalink = ({
  tenantId,
  messengerId,
  messengerToken,
}: {
  tenantId: string;
  messengerId: string;
  messengerToken: string;
}) => {
  const config = useLauncherStore((state) => state.config);
  const revId = config?.revId;

  const createPermalinkPath = useCallback(
    (asset: string, uuid: string) => {
      const origin = import.meta.env.VITE_MESSENGER_API_ORIGIN ?? window.location.origin;
      const path = import.meta.env.VITE_MESSENGER_API_PATH ?? "";
      const queryString = messengerToken ? `?deskproToken=${messengerToken}` : "";
      return `${origin}${path}/${tenantId}/messenger/${messengerId}/${asset}/${uuid}${
        revId ? `/${revId}` : ""
      }${queryString}`;
    },
    [messengerToken, tenantId, messengerId, revId],
  );

  return { createPermalinkPath: createPermalinkPath };
};
